<!--
 * @Descripttion: 带form表单的弹窗模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 21:00:27
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-06-20 10:45:46
-->
<template>
	<el-dialog
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		:width="width"
		:before-close="handleClose"
		:show-close="showClose"
		:close-on-click-modal="closeOnClickModal"
	>
		<div>
			<div class="fz-14 pb-20 pt-8">授权完成后，即可一键同步所有商品</div>

			<!-- 弹窗内容部分 -->
			<el-form :model="formData" :rules="rules" ref="form" :label-width="labelWidth">
				<el-form-item label="团长名称" prop="authorityName">
					<el-input v-model="formData.authorityName" placeholder="请输入" />
				</el-form-item>
				<el-form-item label="AppID(团长ID)" prop="appid">
					<el-input v-model="formData.appid" placeholder="请输入" />
				</el-form-item>
				<el-form-item label="AppSecret(团长密钥)" prop="appsecret">
					<el-input v-model="formData.appsecret" placeholder="请输入" />
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="flex-row flex-just-between">
			<div
				class="fz-12 yx-color-primary cursor-pointer pt-6"
				@click="openBlankWindow('https://yangxuan.feishu.cn/docx/JlYGd8QARogozCxRweTcZsIDnDd?from=from_copylink')"
			>
				完整授权教程
			</div>
			<div>
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="confirm" :loading="loading">确认</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
import { debounce } from 'lodash';
import { sphAuthorize } from '@/api/teamManage';
import mixin from '@/mixins';
export default {
	props: {},
	data() {
		return {
			title: '新增视频号团长', // 弹窗标题
			visible: false, // 弹窗显隐
			formData: {
				authorityName: '',
				appid: '',
				appsecret: '',
			}, // 表单数据
			loading: false, // 按钮loading状态
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DIALOG_SIZE_WIDTH[this.size];
		},
	},
	created() {
		this.initData();
	},
	mixins: [mixin],
	mounted() {},
	methods: {
		// 主动显示弹窗
		init(link, platformId, call_id) {
			this.platformId = platformId;
			this.shopId = call_id;
			this.visible = true;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空表单数据及校验
			this.$refs.form.resetFields();
			// 关闭弹窗
			this.visible = false;

			this.formData = {
				authorityName: '',
				appid: '',
				appsecret: '',
			};
		},
		// 确认按钮点击事件
		confirm: debounce(function () {
			// 校验表单数据
			this.$refs.form.validate(async valid => {
				if (valid) {
					// 按钮loading开启
					this.loading = true;
					try {
						await sphAuthorize({
							platformId: this.platformId,
							applicationId: 1,
							authorityName: this.formData.authorityName,
							appid: this.formData.appid,
							appsecret: this.formData.appsecret,
							shopid: this.shopid || 0,
						});
						this.$message.success('授权成功');
						// 提示授权成功
						// 刷新列表（外部重新获取数据）
						this.$emit('success');
						// 完成之后清空数据
						this.handleClose();
					} finally {
						// 按钮loading关闭
						this.loading = false;
					}
				}
			});
		}, 300),
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 表单项标签宽度
			this.labelWidth = '160px';
			// 是否展示弹窗右上角关闭图标
			this.showClose = true;
			// 弹窗是否添加到body节点下
			this.appendToBody = true;
			// 弹窗尺寸，small:400px，normal:600px，large:800px
			this.size = 'small';
			// 表单校验规则
			this.rules = {
				authorityName: [{ required: true, message: '团长名称必填', trigger: 'blur' }],
				appid: [{ required: true, message: '团长ID必填', trigger: 'blur' }],
				appsecret: [{ required: true, message: '团长密钥必填', trigger: 'blur' }],
			};
			// 点击蒙版是否关闭
			this.closeOnClickModal = false;
		},
	},
	components: {},
	beforeDestroy() {},
};
</script>
